import React from 'react'
import { Icon } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import { Box } from 'ui-components'
import { Spacing } from 'ui-components/box'
import styled from 'styled-components'

const AuthorizedAgencyIcon = ({
  marginLeft = '0',
}: {
  marginLeft?: Spacing
}) => (
  <Box ml={marginLeft}>
    <CustomTooltip minimal content={'Yantrix authorised brand'} >
      <Icon intent={'success'} icon={'endorsed'} iconSize={12} />
    </CustomTooltip>
  </Box>
)

export default AuthorizedAgencyIcon

const CustomTooltip = styled(Tooltip2)`
  display: flex !important;
`